import React from 'react'

import { Box } from 'widgets/Box'
import { Image } from 'widgets/Image'
import { Text } from 'widgets/Text'

import { useGroup } from 'hooks/useGroup'
import { useUser } from 'hooks/useUser'

import { defaultPostThumbnailUrl } from 'utils/media'
import commonStyles from 'utils/styles/commonStyles'

type SponsorItemProps = {
  programId: string
}

export const SponsorItem = ({ programId }: SponsorItemProps) => {
  const { data: sponsoredGroup } = useGroup({ groupId: programId })
  const { data: sponsoredGroupUser } = useUser({ userId: sponsoredGroup?.trainer?.id })

  return (
    <Box width={80} margin={{ vertical: 'sm', left: 'md' }}>
      <Box
        width={80}
        height={80}
        borderRadius='xs'
        backgroundColor='greyLight'
        style={commonStyles.overflowHidden}
      >
        <Image
          resizeMode='cover'
          style={commonStyles.fullSize}
          source={{ uri: sponsoredGroup?.cover?.url ?? defaultPostThumbnailUrl }}
        />
      </Box>
      <Box margin={{ top: 'xs' }}>
        <Text align='center' bold fontSize='sm' numberOfLines={2}>
          {sponsoredGroup?.title ?? ''}
        </Text>
        <Text align='center' fontSize='xs' numberOfLines={1} color='greyDarker'>
          {sponsoredGroupUser?.username ?? ''}
        </Text>
      </Box>
    </Box>
  )
}
